import { DollarSign } from "lucide-react";

const TCBadge = ({ tc }) => {
  if (tc === null || tc === undefined) return null;
  return (
    <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-card border border-border rounded-lg text-sm" data-testid="tc-badge-readonly">
      <DollarSign className="w-3.5 h-3.5 text-[#FF9900]" />
      <span className="text-muted-foreground body-font">TC:</span>
      <span className="mono-font font-semibold text-foreground">{tc} Bs/USD</span>
    </div>
  );
};

export default TCBadge;
